import { render, staticRenderFns } from "./edit-sub.vue?vue&type=template&id=b879f1e6&scoped=true&"
import script from "./edit-sub.vue?vue&type=script&lang=ts&"
export * from "./edit-sub.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b879f1e6",
  null
  
)

export default component.exports